// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'semantic-ui-react';
// local
// actions
import { closeModal, onConfirmClose } from 'app/redux/actions/editConfirm/backModal';

class ConfirmBackModal extends Component {
    componentWillUnmount = () => this.onClose();
    onClose = () => this.props.dispatch(closeModal());
    onClickConfirm = () => this.props.dispatch(onConfirmClose());
    render() {
        const { isOpened } = this.props.modalConfirmEditBack;
        return (
            <Modal open={isOpened} onClose={this.onClose}>
                <Modal.Content>
                    <p className="content text-center">As alterações realizadas não foram salvas e serão perdidas. Tem certeza que deseja prosseguir?</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.onClose}>Cancelar</Button>
                    <Button onClick={this.onClickConfirm} className="highlight">
                        Sim
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

ConfirmBackModal.propTypes = {
    modalConfirmEditBack: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    modalConfirmEditBack: state.modalConfirmEditBack,
});
export default connect(mapStateToProps)(ConfirmBackModal);
